import * as React from 'react'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import Layout from '../components/layout'
import SectionTitle from '../components/section-title'

const IndexPage = () => {
  return (
    <Layout pageTitle="Home Page">
      <section className="relative">
        <StaticImage
          src="../images/home/bow-hunter-binoculars.jpg"
          className="object-cover w-full h-full"
          alt=""
        />
        <div className="absolute inset-0 bg-gray-900 bg-opacity-75">
          <div className="px-4 py-36 sm:py-48 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 md:py-52 lg:px-8 lg:py-96">
            <div className="w-full max-w-xl xl:pr-16 xl:w-7/12">
              <h2 className="max-w-lg font-sans text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight sm:leading-none">
                The authority on hunting and fishing in the Grand Canyon region
              </h2>
            </div>
          </div>
        </div>
      </section>

      <section className="px-4 py-8 lg:px-16 md:py-16 lg:pb-32 bg-topo-map">
        <SectionTitle
          title="Latest Stories"
          textColor="black"
          lineColor="darkGreen"
        />
        <div className="grid gap-1 grid-rows-2 grid-cols-2 lg:grid-cols-3">
          <div className="flex col-span-2 md:col-span-2 overflow-hidden">
            <Link to="/">
              <StaticImage
                className="object-cover w-full h-full transition duration-500 hover:scale-110"
                alt="Image of two guys fishing"
                src="../images/home/trout-3.jpg"
              />
              <div className="relative">
                <h3 className="text-white p-2 leading-tight text-xs sm:text-[18px] absolute bottom-0 w-full bg-opacity70">
                  Find the best local fishing spots
                </h3>
              </div>
            </Link>
          </div>
          <div className="flex overflow-hidden">
            <Link to="/">
              <StaticImage
                className="object-cover w-full h-full transition duration-500 hover:scale-110"
                alt="Image of a man with a bird in a tree"
                src="../images/home/birdguy.jpg"
              />
              <div className="relative">
                <h3 className="text-white p-2 leading-tight text-xs sm:text-[18px] absolute bottom-0 w-full bg-opacity70">
                  Game and Fish monitors eaglets near Cataract Lake
                </h3>
              </div>
            </Link>
          </div>
          <div className="flex overflow-hidden">
            <Link to="/">
              <StaticImage
                className="object-cover w-full h-full transition duration-500 hover:scale-110"
                alt="Image of a man behind a shop counter"
                src="../images/home/bear-tent.jpg"
              />
              <div className="relative">
                <h3 className="text-white p-2 leading-tight text-xs sm:text-[18px] absolute bottom-0 w-full bg-opacity70">
                  What to do if you encounter a bear while camping
                </h3>
              </div>
            </Link>
          </div>
          <div className="flex overflow-hidden">
            <Link to="/">
              <StaticImage
                className="object-cover w-full h-full transition duration-500 hover:scale-110"
                alt="Image of a man behind a shop counter"
                src="../images/home/ranger.jpg"
              />
              <div className="relative">
                <h3 className="text-white p-2 leading-tight text-xs sm:text-[18px] absolute bottom-0 w-full bg-opacity70">
                  An afternoon with a local Forest Ranger
                </h3>
              </div>
            </Link>
          </div>
          <div className="flex overflow-hidden">
            <Link to="/">
              <StaticImage
                className="object-cover w-full h-full transition duration-500 hover:scale-110"
                alt="Image of a man behind a shop counter"
                src="../images/home/elk1.jpg"
              />
              <div className="relative">
                <h3 className="text-white p-2 leading-tight text-xs sm:text-[18px] absolute bottom-0 w-full bg-opacity70">
                  Three different places with the most Elk
                </h3>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <section className="px-4 py-8 lg:px-16 md:py-16 lg:pb-32 bg-pureBlack/90">
        <SectionTitle title="Updates" textColor="gray" lineColor="olive" />
        <div className="flex flex-wrap justify-around">
          <div className="pb-12">
            <div className="max-w-lg relative justify-between">
              <Link to="/">
                <StaticImage
                  className="object-cover w-full h-full"
                  alt="Image of a man drawing a bow and arrow"
                  src="../images/home/archer1.jpg"
                />
              </Link>
              <div className="absolute bottom-0 -mb-8">
                <a href="/">
                  <div className="flex flex-col w-3/4 mx-auto">
                    <h2 className="flex justify-center py-5 bg-opacity70 text-gray">
                      Title
                    </h2>
                    <div className="bg-gray">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Et illum beatae quasi doloribus animi possimus mollitia
                      ipsam, pariatur nobis numquam!
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="pb-12">
            <div className="max-w-lg relative">
              <Link to="/">
                <StaticImage
                  className="object-cover w-full h-full"
                  alt="Image of a man behind a shop counter"
                  src="../images/home/archer1.jpg"
                />
              </Link>
              <div className="absolute bottom-0 -mb-8">
                <a href="/">
                  <div className="flex flex-col w-3/4 mx-auto">
                    <h2 className="flex justify-center py-5 bg-opacity70 text-gray">
                      Title
                    </h2>
                    <div className="bg-gray">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Et illum beatae quasi doloribus animi possimus mollitia
                      ipsam, pariatur nobis numquam!
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="px-4 py-8 lg:px-16 md:py-16 lg:pb-32">
        <SectionTitle
          title="Sponsors"
          textColor="pureBlack"
          lineColor="orange"
        />
        <div className="max-w-7xl mx-auto">
          <p className="text-center text-base font-semibold font-poppins uppercase text-gray-600 tracking-wider text-2xl">
            Supported by these major sponsors
          </p>
          <div className="mt-6 grid grid-cols-2 gap-0.5 md:grid-cols-3 lg:mt-8">
            <div className="col-span-1 flex justify-center p-8 bg-gray-50">
              <img
                className="max-h-12"
                src="https://tailwindui.com/img/logos/mirage-logo-gray-400.svg"
                alt="Sponsor 1"
              />
            </div>
            <div className="col-span-1 flex justify-center p-8 bg-gray-50">
              <img
                className="max-h-12"
                src="https://tailwindui.com/img/logos/tuple-logo-gray-400.svg"
                alt="Sponsor 1"
              />
            </div>
            <div className="col-span-1 flex justify-center p-8 bg-gray-50">
              <img
                className="max-h-12"
                src="https://tailwindui.com/img/logos/transistor-logo-gray-400.svg"
                alt="Sponsor 1"
              />
            </div>
            <div className="col-span-1 flex justify-center p-8 bg-gray-50">
              <img
                className="max-h-12"
                src="https://tailwindui.com/img/logos/laravel-logo-gray-400.svg"
                alt="Sponsor 1"
              />
            </div>
            <div className="col-span-1 flex justify-center p-8 bg-gray-50">
              <img
                className="max-h-12"
                src="https://tailwindui.com/img/logos/statickit-logo-gray-400.svg"
                alt="Sponsor 1"
              />
            </div>
            <div className="col-span-1 flex justify-center p-8 bg-gray-50">
              <img
                className="max-h-12"
                src="https://tailwindui.com/img/logos/statamic-logo-gray-400.svg"
                alt="Sponsor 1"
              />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default IndexPage
